import type { LaunchOption } from '@/hooks/useLauncher';

export const LAUNCH_KEY_OUTLOOK_MULTI: LaunchOption = 'outlook-add:all';

export const isOutlookAddLaunch = (launch: LaunchOption): boolean =>
  launch?.startsWith('outlook-add:') ?? false;
